import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import * as Actions from '../redux/articleActions';
import * as Selectors from '../redux/articleSelectors';
import * as CommonSelectors from '../../../shared/redux/commonSelectors';
import { APP_CONFIG } from '../../../../config/appConfig';
import { objectHelper } from '../../../shared/utils/objectHelper';
import { ROUTES } from '../../../core/router/routes';
import { ArticleParams, ArticleValues } from '../model/articleModel';
import ArticleForm from '../form/ArticleForm';
import SnackbarSettings from '../../../components/Snackbar/SnackbarSettings';
import useMainProgressContext from '../../../components/progress/MainProgress/context/MainProgressContext';
import { ENTITY_ACTIONS } from '../../../components/form/base/EntityForm/enum/entityActions';

const initialValues: ArticleValues = {
  title: '',
  content: '',
  category: '',
  categoryOne: {
    value: '',
    key: '',
  },
  categoryTwo: {
    value: '',
    key: '',
  },
  categoryThree: {
    value: '',
    key: '',
  },
  isPublished: 'false',
  isNotificationNeeded: 'false',
  tags: [],
  keywords: [],
};

const breadcrumbs = [
  {
    label: 'article.add',
    to: null,
  },
];

const ArticleAdd: React.FC = () => {
  const params = useParams<ArticleParams>();
  const dispatch = useDispatch();
  const history = useHistory();
  const apiRequestState = useSelector(Selectors.apiArticleRequestState);
  const apiRequestError = useSelector(Selectors.apiArticleRequestError);
  const rootCategory = useSelector(CommonSelectors.rootCategory);
  const category = useSelector(CommonSelectors.getCategoryById(parseInt(params.id!)));
  const article = useSelector(Selectors.article);
  const { show, hide } = useMainProgressContext();
  const [articleAction, setArticleAction] = useState(ENTITY_ACTIONS.SAVE);

  useEffect(() => {
    if (category) {
      breadcrumbs.push({
        label: category.name,
        to: null,
      });

      hide();
    }
  }, [category]);

  return (
    <>
      <SnackbarSettings
        successMessage={'article.snackbar.add_success'}
        apiRequestState={apiRequestState}
        apiRequestError={apiRequestError}
        setApiRequestState={Actions.setApiArticleRequestState}
        onSuccess={() => {
          if (articleAction === ENTITY_ACTIONS.PREVIEW) {
            window.open(APP_CONFIG.ARTICLE_PREVIEW_URL.replace(':id', article?.id as unknown as string), '_blank');
          }
          history.push(ROUTES.ARTICLE.EDIT.replace(':id', article?.id as unknown as string));
        }}
      />
      <ArticleForm
        apiRequestState={apiRequestState}
        categoryId={rootCategory ? (rootCategory.value as unknown as number) : undefined}
        isMainCategory={true}
        breadcrumbs={breadcrumbs}
        title="article.add"
        initialValues={{
          ...initialValues,
          categoryOne: {
            value: category ? category.name : '',
            key: category ? category.iri : '',
          },
        }}
        onSubmit={(values: ArticleValues, _, type) => {
          show();
          setArticleAction(type!);

          const payload = objectHelper.removeByKeys<ArticleValues>(['categoryOne', 'categoryTwo', 'categoryThree'], {
            ...values,
            category: values.categoryThree.key
              ? values.categoryThree.key
              : values.categoryTwo.key
              ? values.categoryTwo.key
              : values.categoryOne.key,
          });
          dispatch(Actions.addArticle(payload));
        }}
      />
    </>
  );
};

export default ArticleAdd;
